/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRedirect, useTranslate } from 'react-admin';
import { useLocation } from 'react-router-dom';
// 
export const LoginCallback = () => {
  const redirect = useRedirect();
  const translate = useTranslate();
  // access_token, refresh_token, token_type, expired_in, provider_token are returned from the auth provider
  // const tokens: {
  //   access_token: string;
  //   refresh_token: string;
  //   token_type: string;
  //   expired_in: number;
  //   provider_token: string;
  // } = useLocation()
  //   .hash.substring(1)
  //   .split('&')
  //   .reduce((map: any, str: string) => {
  //     const spl = str.split('=');
  //     map[spl[0]] = spl[1];
  //     return map;
  //   }, {});
  // if (!tokens.access_token) {
  //   redirect('/login');
  //   return <>${translate('login.failed')}</>;
  // }
  // supabase.auth.setAuth(tokens.access_token);
  // const { data, error } = await supabase.auth.getSession();
  // const { data: { user } } = await supabase.auth.getUser()


  // if (session) {
  //   // session.refresh_token = tokens.refresh_token;
  // }
  redirect('/');
  return <>${translate('login.successful')}</>;
};
